/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsListAodRunsQueryResponse, AuditReportsListAodRunsQueryParams, AuditReportsListAodRuns401, AuditReportsListAodRuns403 } from "../models/AuditReportsListAodRuns";

export function getAuditReportsListAodRunsUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/aod-runs` as const }
  return res
}

/**
 * @summary Retrieve multiple AodRuns
 * {@link /audit-reports/v1/aod-runs}
 */
export async function auditReportsListAodRuns(params?: AuditReportsListAodRunsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsListAodRunsQueryResponse, ResponseErrorConfig<AuditReportsListAodRuns401 | AuditReportsListAodRuns403>, unknown>({ method : "GET", url : getAuditReportsListAodRunsUrl().url.toString(), params, ... requestConfig })
  return res.data
}